import { render, staticRenderFns } from "./GlazingOptions.vue?vue&type=template&id=4a4632a3&lang=pug"
import script from "./GlazingOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlazingOptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports